module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"email":"E-mail","has already been taken":"がすでに同じ値で登録済みです。","expired":"期限切れです。","ok":"OK","base":" "},"en":{"email":"E-mail","has already been taken":" has already been taken.","expired":" expired","ok":"OK","base":" "}}')
  delete Component.options._Ctor
}
